export default __webpack_public_path__ + "media/images/manual/joanr/10-ac95dfc2c987793ea3ff3a3b660768b4.png";